<div id="login" class="flex flex-col" fusePerfectScrollbar>
  <div id="login-form-wrapper" class="flex flex-col items-center justify-center">
    <div id="login-form" class="fuse-white" [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }">
      <div *ngIf="sendingData">
        <div class="progress-spinner-wrapper w-full h-full flex justify-center items-center">
          <mat-spinner></mat-spinner>
        </div>
      </div>

      <!-- LANGUAGE -->
      <button mat-button class="language-button" [matMenuTriggerFor]="languageMenu">
        <div class="flex justify-center items-center">
          <img class="flag mr-2 w-4" [src]="'./assets/images/flags/' + locale + '.svg'" />
          <span class="iso text-uppercase">{{ locale }}</span>
        </div>
      </button>

      <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
        <button
          mat-menu-item
          *ngFor="let lang of languages"
          [routerLink]="['/' + lang.id + '/#' + getCurrentRoute()]"
          (click)="changeLanguage(lang.id)">
          <div class="flex items-center justify-start">
            <img class="flag mr-4 w-4" [src]="'./assets/images/flags/' + lang.id + '.svg'" />
            <span class="iso">{{ lang.title }}</span>
          </div>
        </button>
      </mat-menu>
      <!-- LANGUAGE / -->

      <div i18n class="title">ВХОД</div>

      <form name="loginForm" [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
        <mat-form-field appearance="outline">
          <mat-label i18n>Email или телефон</mat-label>
          <input data-testid="login" matInput type="text" formControlName="login" />
          <mat-error i18n *ngIf="loginFormErrors.login.required">Поле не должно быть пустым</mat-error>
          <mat-error i18n *ngIf="!loginFormErrors.login.required && loginFormErrors.login.email"
            >Введите действительный Email</mat-error
          >
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label i18n>Пароль</mat-label>
          <input data-testid="password" matInput formControlName="password" [type]="hidePass ? 'password' : 'text'" />
          <mat-icon matSuffix (click)="hidePass = !hidePass"
            >{{ hidePass ? 'visibility' : 'visibility_off' }}
          </mat-icon>
          <mat-error i18n *ngIf="loginFormErrors.password.required">Пароль не задан</mat-error>
        </mat-form-field>

        <div class="remember-forgot-password flex flex-row justify-end items-center">
          <!-- <mat-checkbox class="remember-me" aria-label="Remember Me">
                        Remember Me
                    </mat-checkbox> -->

          <a i18n class="forgot-password" [routerLink]="['/client/auth/forgot-password']">Забыли пароль?</a>
        </div>

        <button
          i18n
          mat-raised-button
          color="accent"
          class="submit-button"
          aria-label="LOG IN"
          [disabled]="userId === 0"
          >ВОЙТИ</button
        >
      </form>
      <!-- 
            <div class="separator">
                <span class="text">OR</span>
            </div>

            <button mat-raised-button class="google">
                Log in with Google
            </button>

            <button mat-raised-button class="facebook">
                Log in with Facebook
            </button> -->

      <div class="register flex flex-col items-center justify-center" *ngIf="userId">
        <span i18n class="text">Еще нет аккаунта?</span>
        <a i18n class="link" [routerLink]="['/client/auth/register']" [queryParams]="{ user: userId }"
          >Создать аккаунт</a
        >
      </div>
    </div>
  </div>
</div>
